import React from 'react';
import PropTypes from 'prop-types';

const IconFleet = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = 'none' }) => {
	return <svg width={width} height={height} viewBox={viewBox} fill={color} xmlns='http://www.w3.org/2000/svg'>
		<path d='M6 5.5V9H5V8.93359L3.52734 9.91602H2.97266L1.5 8.93359V14H3.5V15H1L0.5 14.5V5.5L1 5H5.5L6 5.5ZM11.5 10.5V14.5L11 15H5L4.5 14.5V13H2.5V12H4.5V10.5L5 10H11L11.5 10.5ZM5.5 14H10.5V11H5.5V14ZM9.85352 12.6465L9.14648 13.3535L8.5 12.707L7.85352 13.3535H7.14648L6.14648 12.3535L6.85352 11.6465L7.5 12.293L8.14648 11.6465H8.85352L9.85352 12.6465ZM13.5 8.5V12.5L13 13H12.5V9H6.5V8.5L7 8H13L13.5 8.5ZM15.5 6.5V10.5L15 11H14.5V7H8.5V6.5L9 6H15L15.5 6.5ZM1.5 7.73242L3.25 8.89844L5 7.73242V6H1.5V7.73242ZM7.9502 3.5V7H6.9502V4H2.5498V3.5L3.0498 3H7.4502L7.9502 3.5ZM9.9502 1.5V5H8.9502V2H4.5498V1.5L5.0498 1H9.4502L9.9502 1.5Z' fill='black' />
	</svg>;
};

IconFleet.propTypes = {
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string,
	viewBox: PropTypes.string,
};
export default IconFleet;
